/**
 *
 * CohortsPage
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import { compose } from "redux";

import {
  Button,
  MaterialIcon,
  Input,
} from '@pearsontechnology/aero-components';

import {
  PageWrapper,
  PageViewport,
  PageActions,
  PageActionsRight,
  PageContent,
} from 'components/PageStyles';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { commandWorkspaceCohortList } from 'containers/ConnectionManager/actions';
import { selectModalState } from 'containers/ModalManager/selectors';
import * as modalActions from 'containers/ModalManager/actions';
import enhanceWithImmutable from 'hocs/enhanceWithImmutable';

import { CREATE_COHORT_MODAL } from 'containers/ModalManager/constants';

import { selectFilteredCohortList, selectCohortsSort } from 'Workspace/Cohorts/store/selectors';
import { setSearchQuery, setSortDetails } from 'Workspace/Cohorts/store/actions';
import WorkspaceHeader from 'Workspace/components/WorkspaceHeader';
import Sidebar from 'Workspace/components/WorkspaceSidebar';
import HomeNavigation from 'Workspace/components/HomeNavigation';

import CreateCohortModal from 'Workspace/Cohorts/components/CreateCohortModal';
import { sortType } from 'Workspace/Cohorts/components/constants';

import workspaceService from 'services/WorkspaceService';
import { featureKeys } from 'services/FeatureFlagService';
import gtmService from 'utils/gtm/gtmService';
import { pageName } from 'utils/gtm/constants';
import TabHeader from 'components/TabHeader';
import EmptyState from './EmptyState';
import CohortsList from './CohortsList';
import messages from './messages';
import {
  MenuFilter,
  MenuListFilter,
  CohortsSearch,
  CohortSearchClear,
  FilterContainer,
  PageActionsLeftFlex,
} from './styles';
import {
  MenuListItem,
  MenuListItemText,
  MenuItemIconRightWrapper,
} from '../../../../components/UserProfileMenu/styles';
import enhanceWithFeatureFlagSubscription from 'hocs/enhanceWithFeatureFlagSubscription';

class CohortsPage extends React.Component {
  filterContainerRef = React.createRef(null);

  state = {
    isViewFilterOpen: false,
    selectedViewFilterValue: 'all',
    searchValue: '',
    filteredCohortList: [],
  }

  viewFilterConfig = {
    all: {
      value: 'All',
      message: messages.all,
      catchString: [''],
    },
    manualClasses: {
      value: 'Manual Classes',
      message: messages.manualClasses,
      catchString: [''],
    },
    onDemandClasses: {
      value: 'Ilabs On Demand Classes',
      message: messages.ilabsOndemandClasses,
      catchString: [' On-Demand Cohort Instance', ' On-Demand Cohort Template'],
    },
    bvOnDemandClasses: {
      value: 'BV on Demand Classes',
      message: messages.bvOnDemandClasses,
      catchString: [' Pearson-Plus Cohort', ' Pearson-Plus Test Cohort'],
    },
  }

  componentDidMount() {
    this.props.getCohorts();
    gtmService.pushTelemetryPageActivityAndView({ pageName: pageName.COHORT_PAGE });
    this.selectedWorkspace = workspaceService.getSelectedWorkspace();
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  onSearchChange = (event) => {
    const searchQuery = event.target.value;
    const newList = this.props.cohorts.filter((cohort) => cohort.name.toLowerCase().includes(searchQuery.toLowerCase()));
    this.setState({ searchValue: searchQuery, filteredCohortList: newList });
  }

  componentWillUnmount() {
    this.clearSearch();
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.state.isViewFilterOpen && !this?.filterContainerRef?.current.contains(event.target)) {
      this.setState({ isViewFilterOpen: false });
    }
  }

  clearSearch = () => {
    this.setState({ searchValue: '', filteredCohortList: this.props.cohorts });
  }
  sortBy = (key, type = 'string') => {
    let order = sortType.DESC;
    let sortState = this.props.sortState;
    if (sortState?.order) {
      order = sortState.order === sortType.ASC ? sortType.DESC : sortType.ASC;
    }
    this.props.setSortDetails({ key, type, order });
  };

  toggleViewFilter = () => {
    this.setState({ isViewFilterOpen: !this.state.isViewFilterOpen });
  }

  setViewFilterValue = (key) => {
    this.setState({ selectedViewFilterValue: key });
  }

  getFilteredList = (cohorts) => {
    const selectedView = this.state.selectedViewFilterValue;
    const viewConfig = this.viewFilterConfig;
    if (selectedView === 'manualClasses') {
      return cohorts.filter((cohort) => {
        const nameArray = cohort.name.split(':');
        if (nameArray.length === 1) {
          return cohort;
        }
      });
    } else {
      //if not selectedView === 'all' and not selectedView === 'manualClasses' and catchString given in viewFilterConfig case.
      return cohorts.filter((cohort) => {
        const nameArray = cohort.name.split(':');
        if (nameArray.length > 1 && (viewConfig[selectedView].catchString.includes(nameArray[nameArray.length - 1]))) {
          return cohort;
        }
      });
    }
  }

  render() {
    const {
      cohorts,
      sortState,
      isCreateCohortModalShown,
      showCreateCohortModal,
      hideCreateCohortModal,
      getFeatureFlagValue,
    } = this.props;
    const { searchValue, isViewFilterOpen } = this.state;
    const isTabHeaderVisible = getFeatureFlagValue(featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22);
    const filteredCohortList = searchValue ? this.state.filteredCohortList : this.state.selectedViewFilterValue === 'all' ? cohorts : this.getFilteredList(cohorts);
    return (
      <PageWrapper>
        <CreateCohortModal visible={isCreateCohortModalShown} onDismiss={hideCreateCohortModal} />
        <Sidebar navigation={<HomeNavigation selectedKey="classes" />} />
        <PageViewport>
          {isTabHeaderVisible ? <WorkspaceHeader title={this.selectedWorkspace && this.selectedWorkspace.name} />
            : <WorkspaceHeader title={intl.formatMessage(messages.cohorts)} />}
          {isTabHeaderVisible && <TabHeader></TabHeader>}
          <PageActions>
            <PageActionsLeftFlex>
              <CohortsSearch>
                <Input.Search
                  width={'50%'}
                  value={searchValue}
                  onChange={(e) => this.onSearchChange(e)}
                  placeholder={intl.formatMessage(messages.search)}
                  label={intl.formatMessage(messages.search)}
                />
                {searchValue &&
                  <CohortSearchClear
                    grey
                    rounded
                    onClick={() => this.clearSearch()}
                    data-testid="clearButton"
                  >
                    <MaterialIcon id="close" />
                  </CohortSearchClear>
                }
              </CohortsSearch>
              <FilterContainer isViewFilterOpen={isViewFilterOpen} ref={this.filterContainerRef}>
                <MenuFilter
                  width={isViewFilterOpen ? 200 : 50}
                  height={isViewFilterOpen ? 156 : 50}
                  isViewFilterOpen={isViewFilterOpen}
                >
                  <Transition
                    mountOnEnter
                    unmountOnExit
                    in={!isViewFilterOpen}
                    timeout={{ enter: 0, exit: 300 }}
                  >
                    {(status) => (
                      <MenuListFilter status={status} direction={-1}>
                        <MenuListItem onClick={this.toggleViewFilter}>
                          <MenuItemIconRightWrapper>
                            <MaterialIcon id="filter_list" />
                          </MenuItemIconRightWrapper>
                        </MenuListItem>
                      </MenuListFilter>
                    )}
                  </Transition>
                  <Transition
                    mountOnEnter
                    unmountOnExit
                    in={isViewFilterOpen}
                    timeout={{ enter: 0, exit: 300 }}
                  >
                    {(status) => (
                      <MenuListFilter status={status} direction={1}>
                        {
                          Object.keys(this.viewFilterConfig).map((key) => (<MenuListItem selected={key === this.state.selectedViewFilterValue} key={key} onClick={() => { this.setViewFilterValue(key); }}>
                            <MenuListItemText>
                              {intl.formatMessage(this.viewFilterConfig[key].message)}
                            </MenuListItemText>
                          </MenuListItem>)
                          )
                        }
                      </MenuListFilter>
                    )}
                  </Transition>
                </MenuFilter>
              </FilterContainer>
            </PageActionsLeftFlex>
            <PageActionsRight>
              <Button primary onClick={showCreateCohortModal}>
                <MaterialIcon id="add" left />
                {intl.formatMessage(messages.newCohort)}
              </Button>
            </PageActionsRight>
          </PageActions>
          <PageContent>
            {
              (() => {
                if (!cohorts?.length) {
                  return <EmptyState showCreateCohortModal={showCreateCohortModal} />;
                }
                return <CohortsList cohorts={filteredCohortList}
                  sortBy={(sortId, type) => this.sortBy(sortId, type)}
                  sortState={sortState} />;
              })()
            }
          </PageContent>
        </PageViewport>
      </PageWrapper>
    );
  }
}

CohortsPage.propTypes = {
  cohorts: PropTypes.array,
  setSearchQuery: PropTypes.func,
  setSortDetails: PropTypes.func,
  getCohorts: PropTypes.func,
  showCreateCohortModal: PropTypes.func,
  hideCreateCohortModal: PropTypes.func,
  isCreateCohortModalShown: PropTypes.bool,
  location: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => ({
  getCohorts: () => dispatch(commandWorkspaceCohortList()),
  setSearchQuery: (searchQuery) => dispatch(setSearchQuery(searchQuery)),
  setSortDetails: (sortDetails) => dispatch(setSortDetails(sortDetails)),
  showCreateCohortModal: () =>
    dispatch(modalActions.showModal(CREATE_COHORT_MODAL)),
  hideCreateCohortModal: () =>
    dispatch(modalActions.hideModal(CREATE_COHORT_MODAL)),
});

const mapStateToProps = (state) => ({
  cohorts: selectFilteredCohortList(state),
  sortState: selectCohortsSort(state),
  isCreateCohortModalShown: selectModalState(state, CREATE_COHORT_MODAL),
});

const flagNames = [featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22];
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect, enhanceWithImmutable)(enhanceWithFeatureFlagSubscription(CohortsPage, flagNames));
